import styles from '@runtime/features/poster/components/PosterThemeStatus.module.scss'

type PosterThemeStatusProps = {
  message: string
  overlay?: boolean
}

export default function PosterThemeStatus({
  message,
  overlay = false,
}: PosterThemeStatusProps) {
  if (overlay) {
    return (
      <div className={styles.applyOverlay} role="status" aria-live="polite">
        <div className={styles.applyPanel}>
          <div className={styles.spinner} aria-hidden="true" />
          <div>{message}</div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.loading} aria-live="polite">
      <div className={styles.spinner} aria-hidden="true" />
      <span>{message}</span>
    </div>
  )
}
